export const onPageChange = async (setparams, params, page) => {
  setparams({ ...params, page: page });
};
